module.exports = __webpack_public_path__ + "static/media/prakash.f3753704.png";